interface BootFailureScreenProps {
  fields: string[];
}

/** The honest boot-failure state (TASK.md "Env (fail closed at boot)"): a missing required
 * field renders this, naming the field — never a blank page, never a silent default. */
export function BootFailureScreen({ fields }: BootFailureScreenProps) {
  const named = fields.length === 1 ? fields[0] : fields.join(", ");
  const verb = fields.length === 1 ? "is" : "are";

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-2 bg-background px-6 text-center">
      <p className="text-section-title text-foreground">The admin can't start.</p>
      <p className="text-body text-muted-foreground">
        {named} {verb} missing from the environment.
      </p>
    </div>
  );
}
